import type { SkillSummary, SkillDetail, McpConfigResponse } from '../types/team.js';

const TEAM_URL = '/api/team';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getSkills(projectId?: number): Promise<SkillSummary[]> {
  const params = projectId ? `?projectId=${projectId}` : '';
  return fetchJson<SkillSummary[]>(`${TEAM_URL}/skills${params}`);
}

export async function getSkillDetail(skillId: string): Promise<SkillDetail> {
  return fetchJson<SkillDetail>(`${TEAM_URL}/skills/${encodeURIComponent(skillId)}`);
}

export async function updateSkill(skillId: string, content: string, mcpTools?: string[]): Promise<SkillDetail> {
  return fetchJson<SkillDetail>(
    `${TEAM_URL}/skills/${encodeURIComponent(skillId)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content, mcpTools }),
    },
  );
}

export async function createSkill(id: string, name: string, description: string): Promise<SkillDetail> {
  return fetchJson<SkillDetail>(
    `${TEAM_URL}/skills`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, name, description }),
    },
  );
}

export async function getMcpConfig(): Promise<McpConfigResponse> {
  return fetchJson<McpConfigResponse>(`${TEAM_URL}/mcp-config`);
}

export async function deleteSkill(skillId: string): Promise<void> {
  const response = await fetch(
    `${TEAM_URL}/skills/${encodeURIComponent(skillId)}`,
    { method: 'DELETE' },
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
}
